import contractInterestSettingService from "@services/contractInterestSetting/contractInterestSettingService"
import type { IContractInterestSetting } from "@services/contractInterestSetting/contractInterestSettingService"
import { action, makeAutoObservable, observable } from "mobx"

class ContractInterestSettingStore {
  @observable isLoading: boolean = false
  @observable settingData: IContractInterestSetting | null = null

  constructor() {
    makeAutoObservable(this)
  }

  @action
  async get(contractId: number): Promise<void> {
    this.isLoading = true
    try {
      this.settingData = await contractInterestSettingService.get(contractId)
    } finally {
      this.isLoading = false
    }
  }

  @action
  async createOrUpdate(body: IContractInterestSetting): Promise<void> {
    this.isLoading = true
    try {
      this.settingData = await contractInterestSettingService.createOrUpdate(body)
    } finally {
      this.isLoading = false
    }
  }

  @action
  async deleteSetting(id: number): Promise<void> {
    this.isLoading = true
    try {
      await contractInterestSettingService.delete(id)
      this.settingData = null
    } finally {
      this.isLoading = false
    }
  }
}

export default ContractInterestSettingStore
